"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var withStyles_1 = require("../decorators/withStyles");

var Pulsar_styles_1 = require("./Pulsar.styles");

var Pulsar =
/** @class */
function (_super) {
  __extends(Pulsar, _super);

  function Pulsar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Pulsar.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        _c = _b.sizeX,
        sizeX = _c === void 0 ? 8 : _c,
        secondary = _b.secondary,
        fixed = _b.fixed,
        theme = _b.theme;
    var sizeMultiple = sizeX * theme.x1;
    var inlineStyles = {
      width: sizeMultiple,
      height: sizeMultiple
    };
    var className = classnames_1.default(classes.base, (_a = {}, _a[classes.secondary] = secondary, _a[classes.fixed] = fixed, _a));
    return react_1.default.createElement("span", __assign({}, baseProps_1.default(this.props), {
      className: className,
      style: inlineStyles
    }));
  };

  Pulsar = __decorate([withStyles_1.withStyles(Pulsar_styles_1.styles)], Pulsar);
  return Pulsar;
}(react_1.default.PureComponent);

exports.default = Pulsar;